import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addNews } from "../../actions/newsAction";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';

import 'react-toastify/dist/ReactToastify.css';

class NewsAddModel extends React.Component {

  constructor() {
    super();
    this.state = {
      name: "",
      short_name: "",
      order_sequence: "",
      errors: {},
      coinImage: '',
      is_deposit: 0,
      is_withdrawal: 0,
      is_trade: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors
      });
    }

  }
  handleChange = (event) => {
    let { name, value } = event.target;
    //console.log("valuefdvfdv",event.target)
    this.setState({ [name]: value, emptyField: false, errMsg: "" });
  };

  onChange = e => {
    console.log("valueof e", e)

    if (e.target.name === 'currencyImage') {
      var currencyImage = e.target.files[0];

      var fileSize = e.target.files[0].size;
      console.log(this.state.invalidImage);
      if (!currencyImage.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        this.setState({ invalidImage: "Please select valid image jpeg,png,gif.", userUploadImage: false });
        return false;
      }
      this.setState({
        coinImage: currencyImage,
      });
    }
    else {
      this.setState({ [e.target.id]: e.target.value })
    }
  }

  onCryptoAdd = e => {
    e.preventDefault();

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }

    const formData = new FormData();
    formData.append('currencyImage', this.state.coinImage);
    formData.append('bankname', this.state.bankname);
    formData.append('accountnumber', this.state.accountnumber);
    formData.append('ifsccode', this.state.ifsccode);
    formData.append('accountholder', this.state.accountholder);
    formData.append('branchname', this.state.branchname);
    formData.append('upi_id', this.state.upi_id);
    this.props.addNews(formData, config);
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <div className="modal fade" id="add-user-modal" data-reset="true" data-backdrop="static">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">User Info Model</h4>
                <button type="button" className="close" data-dismiss="modal">&times;</button>
              </div>
              <div className="modal-body">
                <form noValidate onSubmit={this.onCryptoAdd} id="add-user">
                  <div className="row">
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Bank Name</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.bankname}
                          id="bankname"
                          name="bankname"
                          type="text"
                          error={errors.bankname}
                          className={classnames("form-control", {
                            invalid: errors.bankname
                          })} />
                        <span className="text-danger">{errors.bankname}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Account Number</label>
                        <textarea
                          onChange={this.onChange}
                          value={this.state.accountnumber}
                          id="accountnumber"
                          name="accountnumber"
                          type="text"
                          error={errors.accountnumber}
                          className={classnames("form-control", {
                            invalid: errors.accountnumber
                          })} />
                        <span className="text-danger">{errors.accountnumber}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">IFSC Code</label>
                        <textarea
                          onChange={this.onChange}
                          value={this.state.ifsccode}
                          id="ifsccode"
                          name="ifsccode"
                          type="text"
                          error={errors.ifsccode}
                          className={classnames("form-control", {
                            invalid: errors.ifsccode
                          })} />
                        <span className="text-danger">{errors.ifsccode}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='from-group'>
                        <label htmlFor="name">Account Holder Name</label>
                        <textarea
                          onChange={this.onChange}
                          value={this.state.accountholder}
                          id="accountholder"
                          name="accountholder"
                          type="text"
                          error={errors.accountholder}
                          className={classnames("form-control", {
                            invalid: errors.accountholder
                          })} />
                        <span className="text-danger">{errors.accountholder}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Branch Name</label>
                        <textarea
                          onChange={this.onChange}
                          value={this.state.branchname}
                          id="branchname"
                          name="branchname"
                          type="text"
                          error={errors.branchname}
                          className={classnames("form-control", {
                            invalid: errors.branchname
                          })} />
                        <span className="text-danger">{errors.branchname}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">UPI Id</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.upi_id}
                          id="upi_id"
                          name="upi_id"
                          type="text"
                          error={errors.upi_id}
                          className={classnames("form-control", {
                            invalid: errors.upi_id
                          })} />
                        <span className="text-danger">{errors.upi_id}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">UPI Image</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.currencyImage}
                          id="currencyImage"
                          name="currencyImage"
                          type="file"
                          error={errors.currencyImage}
                          className={classnames("form-control", {
                            invalid: errors.currencyImage
                          })} />
                        <span className="text-danger">{errors.currencyImage}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  form="add-user"
                  type="submit"
                  className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NewsAddModel.propTypes = {
  addNews: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { addNews }

)(withRouter(NewsAddModel));